import { catalogs } from "../../../texts/esp/catalogs";

export const content = {
    header:[
        {id:0,label:'',hidden:false, fixed:true, width:26, position:0, padding:'checkbox'},
        {id:1,key:'fixed_business_name',label:'Razón Social',hidden:false, width:300, fixed:true, add:{icon:'add'}, position:34},
        {id:2,key:'rfc',label:'RFC',hidden:false},
        {id:3,key:'client_classification',label:'Clasificación',hidden:false},
        {id:4,key:'client_status_id',label:'Estatus',hidden:false},
        {id:5,key:'fixed_client_responsible',label:'Asesor',hidden:false},
        //Fixed other data
        {id:6,key:'fiscal_regime',label:'Regimen Fiscal',hidden:false, add:{icon:'add'}},
        {id:7,key:'sub_activity',label:'Sub-Actividad',hidden:false},
        /// New data
        {id:20,key:'process_status_id',label:'Estatus',hidden:false},
        {id:21,key:'declaration_period',label:'Periodo',hidden:false},
        {id:22,key:'declaration_type',label:'Tipo',hidden:false},
        {id:23,key:'accumulated_income',label:'Ingresos Acumulables',hidden:false},
        {id:24,key:'deductions',label:'Deducciones',hidden:false},
        {id:25,key:'fiscal_utility',label:'Unidad Fiscal / Pérdida',hidden:false},
        {id:26,key:'isr_to_pay',label:'ISR a Pagar',hidden:false},
        {id:27,key:'total_to_pay',label:'Total a Pagar',hidden:false},
        {id:28,key:'cu_present_year', label:'C.U. Año Presente',hidden:false},
        {id:29,key:'cu_last_year', label:'C.U. Año Pasado',hidden:false},
        {id:30,key:'accumulated_loses',label:'Pérdidas Acumuladas',hidden:false},
        {id:31,key:'exercise_loses',label:'Pérdida del Ejercicio',hidden:false},
        {id:32,key:'isr_in_favor',label:'ISR a Favor',hidden:false},
        {id:33,key:'operation_number',label:'Número de Operación',hidden:false},
        {id:34,key:'presentation_date',label:'Fecha de Presentación',hidden:false},
        {id:35,label:'Hoja de Trabajo',hidden:false},
        {id:36,label:'Acuse Anual',hidden:false},
        {id:37,label:'Detalle Doc',hidden:false},
        //////////////
        {id:43,key:'delivery_date',label:'Fecha de Entrega',hidden:false},
        {id:44,key:'responsible',label:'Responsable',hidden:false},
        {id:45,key:'notes',label:'Notas',hidden:false},
        {id:46,key:'completition_date',label:'Fecha de Completado',hidden:false},
        {id:47,label:'Completado',hidden:false},

    ],
    dataConfig:[
        {id:'fixed_business_name',type:'text',fixed:true, editBtn:true, position:34},
        {id:'rfc',type:'text'},
        {id:'client_classification', type:'text'},
        {id:'client_status_id',type:'status', options: [...catalogs.client_statuses] },
        {id:'fixed_client_responsible',type:'text'},
        ///////// second fixed data
        {id:'fiscal_regime',type:'text'},
        {id:'sub_activity',type:'text'},
        // Real data
        {id:'process_status_id', type:'status', options: [...catalogs.ctrl_process_statuses], editable:true},
        {id:'declaration_period',formId:'declaration_period_id', type:'text',editable:true},
        {id:'declaration_type',formId:'declaration_type_id', type:'text',editable:true},
        {id:'accumulated_income',type:'cash', editable:true},
        {id:'deductions',type:'cash', editable:true},
        {id:'fiscal_utility',type:'cash', editable:true},
        {id:'isr_to_pay',type:'cash', editable:true},
        {id:'total_to_pay',type:'cash', editable:true},
        {id:'cu_present_year',type:'text', editable:true},
        {id:'cu_last_year',type:'text', editable:true},
        {id:'accumulated_loses',type:'text', editable:true},
        {id:'exercise_loses',type:'text',editable:true},
        {id:'isr_in_favor', type:'text',editable:true},
        {id:'operation_number',type:'text',editable:true},
        {id:'presentation_date',type:'date',variant:'date',editable:true},
        {id:'worksheet',type:'document'},
        {id:'annual_receipt',type:'document'},
        {id:'details_document',type:'document'},
        {id:'delivery_date',type:'date',variant:'date',editable:true},
        {id:'responsible',formId:'responsible_id', type:'text', editable:true},
        {id:'notes',type:'text',editable:true},
        {id:'completition_date',type:'date', variant:'date',editable:true},
        {id:'completed',type:'checkbox',editable:true},
    ]
}